import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, Backdrop, CircularProgress, Grid, TextField, Divider } from '@material-ui/core';
import { palette } from 'configurations/styles/theme';
import { retentionCode, typeTax, retentionCodeIva, retentionCodeIcd, typeInvoice } from 'views/facturacion/Forms/typeVoucher';
import { Autocomplete } from '@material-ui/lab';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es";
import InputMask from "react-input-mask";
import useAddTax from "hooks/useAddTax";


const AddTax = ({ impuestoRetencions, setImpuestoRetencions, viewDetalle, setViewDetalle, taxDetail, setTaxDetail }) => {

    const {
        classes,
        classesApp,
        classesGlobales,
        minDate1,
        open,
        openLoader,
        setOpenLoader,
        retention,
        tax,
        retainedValue,
        fechaEmisionDocSustento,
        docSustento,
        dataTax,
        setDataTax,
        retentionTax,
        empty,
        handleClickOpen,
        handleClose,
        handleChangeData,
        calculateRetainedValue,
        handleChangeDocSustento,
        handleAddTax,
        setTax,
        setRetentionTax,
        setEmty,
        setRetention,
        setRetainedValue,
        setDocSustento,
        setFechaEmisionDocSustento
    } = useAddTax(impuestoRetencions, setImpuestoRetencions, viewDetalle, setViewDetalle, taxDetail, setTaxDetail);

    return (
        <>
            <Grid container justify='center' className={classes.divButton} >
                <Button variant="outlined" color="primary" onClick={handleClickOpen}>
                    Agregar Impuesto
            </Button>
            </Grid>
            <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}
                disableBackdropClick
                disableEscapeKeyDown
            >
                <DialogTitle id="max-width-dialog-title">Nuevo Impuesto</DialogTitle>
                <DialogContent>
                    <form onSubmit={() => { setOpenLoader(true); }}>
                        <Grid container direction="row" justify="flex-start" alignItems="center" >
                            <Grid item xs={12} md={12}>
                                <label>Los campos marcados con (  <font color={palette.error.main}> *</font> ) son obligatorios:</label>
                            </Grid>

                            <Grid item xs={12} md={4} className={classes.divForm}>
                                <label>Código impuesto: <font color={palette.error.main}>*</font></label>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Autocomplete
                                    id="combo-box-demo"
                                    size='medium'
                                    value={tax}
                                    options={typeTax}
                                    noOptionsText="No se encontró datos con el argumento ingresado"
                                    onChange={(event, newValue) => {
                                        setDataTax();
                                        if (newValue) {
                                            if (newValue.CODIGO === '1') {
                                                setDataTax(retentionCode)
                                            } else if (newValue.CODIGO === '2') {
                                                setDataTax(retentionCodeIva)
                                            } else if (newValue.CODIGO === '6') {
                                                setDataTax(retentionCodeIcd)
                                            }
                                        } else {
                                            setDataTax()
                                        }
                                        setTax(newValue);
                                        setRetentionTax({ ...retentionTax, ['codigoImpuesto']: newValue ? newValue.CODIGO ? newValue.CODIGO : '' : '' })
                                        setEmty({ ...empty, ['impuesto']: true })
                                        setRetention({
                                            CODIGO: '',
                                            VALOR: '',
                                            NOMBRE: ''
                                        });
                                        setRetainedValue();
                                    }}
                                    getOptionLabel={(option) => `${option.CODIGO}-${option.NOMBRE}`}
                                    //style={{ width: 700 }}
                                    renderInput={(params) => <TextField {...params} className='form-control' variant="outlined" placeholder="Seleccione" />}
                                />
                                {empty.impuesto === true ?
                                    null
                                    :
                                    <p className={classesApp.errorLetters}>Debe seleccionar un impuesto</p>
                                }
                            </Grid>

                            <Grid item xs={12} md={4} className={classes.divForm}>
                                <label>Código retención: <font color={palette.error.main}>*</font></label>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                {dataTax ?
                                    <Autocomplete
                                        id="combo-box-demo"
                                        size='medium'
                                        value={retention}
                                        options={dataTax}
                                        noOptionsText="No se encontró datos con el argumento ingresado"
                                        onChange={(event, newValue) => {
                                            if (newValue) {
                                                setRetention(newValue);
                                            } else {
                                                setRetention({
                                                    CODIGO: '',
                                                    VALOR: '',
                                                    NOMBRE: ''
                                                });
                                            }
                                            setRetentionTax({ ...retentionTax, ['codigoRetencion']: newValue ? newValue.CODIGO ? newValue.CODIGO : '' : '' })
                                            calculateRetainedValue(retentionTax ? retentionTax.baseImponible ? retentionTax.baseImponible : 0 : 0, newValue ? newValue.VALOR ? newValue.VALOR : 0 : 0)
                                            setEmty({ ...empty, ['retencion']: true })
                                        }}
                                        getOptionLabel={(option) => `${option.CODIGO}-${option.NOMBRE}`}
                                        renderInput={(params) => <TextField {...params} className='form-control' variant="outlined" placeholder="Seleccione" />}
                                    />
                                    : null

                                }

                                {empty.retencion === true ?
                                    null
                                    :
                                    <p className={classesApp.errorLetters}>Debe seleccionar un codigo de retención</p>
                                }
                            </Grid>

                            <Grid item xs={12} md={4} className={classes.divForm}>
                                <label>Porcentaje a Retener: <font color={palette.error.main}>*</font></label>
                            </Grid>
                            <Grid fullWidth item xs={12} md={8} >
                                <input className={retention ? retention.VALOR ? "form-control  is-valid" : "form-control" : "form-control "}
                                    type="text"
                                    placeholder="Ej. 10"
                                    name="VALOR"
                                    value={retention ? retention.VALOR : ''}
                                    onChange={event => handleChangeData(event)}
                                    autoComplete="off"
                                />
                                {empty.codigo === true ?
                                    null
                                    :
                                    <p className={classesApp.errorLetters}>Debe ingresar un valor</p>
                                }
                            </Grid>

                            <Grid item xs={12} md={4} className={classes.divForm}>
                                <label>Base Imponible: <font color={palette.error.main}>*</font></label>
                            </Grid>
                            <Grid fullWidth item xs={12} md={8} >
                                <input className={retentionTax ? retentionTax.baseImponible !== 0 && retentionTax.baseImponible.trim() !== '' ? "form-control  is-valid" : 'form-control' : 'form-control'}
                                    type="text"
                                    placeholder="Ej. 123"
                                    name="baseImponible"
                                    value={retentionTax.baseImponible}
                                    onChange={event => handleChangeData(event)}
                                    autoComplete="off"
                                />
                                {empty.base === true ?
                                    null
                                    :
                                    <p className={classesApp.errorLetters}>Ingrese un dato válido</p>
                                }
                            </Grid>

                            <Grid item xs={12} md={4} className={classes.divForm}>
                                <label>Valor Retenido: <font color={palette.error.main}>*</font></label>
                            </Grid>
                            <Grid fullWidth item xs={12} md={8} >
                                <input className={retainedValue ? "form-control  is-valid" : 'form-control'}
                                    type="text"
                                    placeholder="Ej. 123"
                                    disabled
                                    name="valor"
                                    value={retainedValue ? retainedValue : ''}
                                    //onChange={handleChange}
                                    autoComplete="off"
                                />
                            </Grid>

                            <Grid item xs={12} md={4} className={classes.divForm}>
                                <label>Código documento Sustento: <font color={palette.error.main}>*</font></label>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                {<Autocomplete
                                    id="combo-box-demo"
                                    size='medium'
                                    value={docSustento}
                                    options={typeInvoice}
                                    onChange={(event, newValue) => {
                                        setEmty({
                                            ...empty, ['documento']: true,
                                            ['numero']: true
                                        })
                                        setDocSustento(newValue);
                                        setRetentionTax({ ...retentionTax, ['codigoDocSustento']: newValue ? newValue.CODIGO ? newValue.CODIGO : '' : '' })
                                    }}
                                    getOptionLabel={(option) => `${option.CODIGO}-${option.NOMBRE}`}
                                    renderInput={(params) => <TextField {...params} className='form-control' variant="outlined" placeholder="Seleccione" />} />}
                                {empty.documento === true ?
                                    null
                                    :
                                    <p className={classesApp.errorLetters}>Seleccione el tipo de documento sustento</p>
                                }
                            </Grid>



                            <Grid item xs={12} md={4} className={classes.divForm}>
                                <label>Número Doc. Sustento: <font color={palette.error.main}>*</font></label>
                            </Grid>
                            <Grid fullWidth item xs={12} md={8} >
                                <InputMask className={retentionTax ? retentionTax.numeroDocSustento !== '' ? "form-control  is-valid" : "form-control" : "form-control"}
                                    type="text"
                                    placeholder="Ej. 001-001-000000321"
                                    mask="999-999-999999999"
                                    name="numeroDocSustento"
                                    value={retentionTax ? retentionTax.numeroDocSustento ? retentionTax.numeroDocSustento : '' : ''}
                                    onChange={handleChangeDocSustento}
                                    //inputComponent={TextMaskCustom}
                                    autoComplete="off"
                                />

                                {empty.numero === true ?
                                    null
                                    :
                                    <p className={classesApp.errorLetters}>Ingrese el número de documento sustento válido</p>
                                }
                            </Grid>

                            <Grid item xs={12} md={4} className={classes.divForm}>
                                <label>Fecha Emisión Doc. Sustento: <font color={palette.error.main}>*</font></label>
                            </Grid>
                            <Grid item xs={12} md={8} >
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                    <DatePicker
                                        className={fechaEmisionDocSustento ? "form-control  is-valid" : "form-control "}
                                        disableToolbar
                                        autoOk
                                        disableFuture
                                        minDate={minDate1}
                                        InputAdornmentProps={{ position: "start" }}
                                        variant="dialog"
                                        inputVariant="outlined"
                                        cancelLabel="Cancelar"
                                        okLabel="Seleccionar"
                                        invalidDateMessage="Formato inválido."
                                        format='dd-MM-yyyy'
                                        name='fechaEmisionDocSustento'
                                        value={fechaEmisionDocSustento}
                                        onChange={setFechaEmisionDocSustento}
                                    />
                                </MuiPickersUtilsProvider>
                                {empty.fecha === true ?
                                    null
                                    :
                                    <p className={classesApp.errorLetters}>seleccione la fecha</p>
                                }
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <Divider />
                            </Grid>
                            <Grid item xs={12} md={12} className={classes.divButton}>
                                <Button variant="contained" color="primary" onClick={handleAddTax} className={classesGlobales.button}>
                                    Agregar
                                </Button>
                                <Button variant="outlined" color="secondary" onClick={handleClose} className={classesGlobales.button}>
                                    Cancelar
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
            </Dialog>
            <Backdrop className={classes.backdrop} open={openLoader} >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default AddTax;